import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

export function useCustomerVerifiedEmails(customerId) {
  const [loading, setLoading] = useState(true);
  const [verifiedEmails, setVerifiedEmails] = useState([]);

  useEffect(() => {
    if (!customerId) {
      setVerifiedEmails([]);
      setLoading(false);
      return () => {};
    }
    setLoading(true);
    const db = firebase.firestore();
    const unsubscribe = db
      .collection('customers')
      .doc(customerId)
      .collection('verifiedEmails')
      .onSnapshot(
        (snap) => {
          setVerifiedEmails(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
          setLoading(false);
        },
        (err) => {
          console.error('[useCustomerVerifiedEmails] Failed:', err);
          setVerifiedEmails([]);
          setLoading(false);
        },
      );
    return () => unsubscribe();
  }, [customerId]);

  return [loading, verifiedEmails];
}
